/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Container, Breadcrumb, BreadcrumbItem, CardText, CardTitle, Card, Button, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Spinner } from 'reactstrap';
import { GoogleMap, useJsApiLoader, Marker, InfoWindow, DirectionsRenderer } from '@react-google-maps/api';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import './AlongRoute.scss';
import { showPointList } from '../../utils/action/Action';
import { FiShare2, FiBriefcase } from "react-icons/fi";
import { AiOutlineStar, AiFillStar } from "react-icons/ai";
import { MdLocationOn } from "react-icons/md";
import { BiDotsVerticalRounded, BiExitFullscreen } from "react-icons/bi";
import swal from 'sweetalert';
import { addUserFavorite, removeUserFavorite } from '../../services/favourites.service';
import ReportSuggestionModal from '../../components/Modals/ReportSuggestionModal';
import ShareModal from '../../components/Modals/ShareModal';
import { updateRouteDetail } from '../../services/myRoute.service';
import { deductPoints, getUserPoints } from '../../services/points.service';
import marked_pop from "../../assets/marked_pop.svg";

const containerStyle = {
    width: '100%',
    height: '650px'
};

const center = {
    lat: 48.019573,
    lng: 66.923683,
};

const options = {
    minZoom: 2,
    maxZoom: 17,
    gestureHandling: 'greedy'
}

function AlongRoute({ isUserLoggedIn, getPoints }) {
    const [activeMarker, setActiveMarker] = useState(null);
    const [dropdownMenuOpen, setMenuOpen] = useState(false);
    const [showReportModal, setShowReportModal] = useState(false);
    const [showShareModal, setShowShareModal] = useState(false);
    const [pointName, setPointName] = useState(null);
    const [showListModal, setShowListModal] = useState(false);
    const [routeName, setRouteName] = useState(null);
    const [map, setMap] = useState(/**@type window?.google?.maps?.Map*/(null));
    const userName = useSelector((state) => state.userDetailReducer.userData.userName);
    const [checkForFavorite, setCheckForFavorite] = useState(null);
    const [mkmID, setMkmId] = useState();
    const [directionResponse, setDirectionResponse] = useState();
    const [startPoint, setStartPoints] = useState();
    const [endPoint, setEndPoints] = useState();
    const [showPathWayPoint, setShowPathWayPoints] = useState([]);
    const [showPathSpinner, setShowPathSpinner] = useState(false);

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const location = useLocation();

    const markers = useSelector((state) => state?.pointListReducer?.pointListData);
    console.log(markers);

    const [link, setLink] = useState('');

    const { isLoaded } = useJsApiLoader({
        googleMapsApiKey: "AIzaSyDzh8-GocyaUY-Y1vg21IVA5M0vx6RuqI8"
    });

    useEffect(() => {
        setTimeout(() => {
            window?.scrollTo({ top: 0, behavior: 'smooth' })
        }, 0);
    }, []);

    useEffect(() => {
        fetchPointList();
    }, []);

    const fetchPointList = async () => {
        try {
            dispatch(showPointList());
        } catch (error) {
            toast.error(
                error?.startPoint?.message ||
                "Oops.. something went wrong, try again !!!",
                {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 2000,
                }
            );
        }
    }

    const addToRoute = (id) => {
        if (location?.state?.data[0]?.key === 'addPointAbove') {
            addPointAbove(id)
        }
        else if (location?.state?.data[0]?.key === 'addPoints') {
            addPointInLast(id)
        }
        else {
            setMkmId(id)
        }
    };

    const onLoad = useCallback(async function callback(map) {
        const arr = location?.state?.data[0]?.arr
        var wayPoint;
        var startPoints;
        var endPoints;
        var showPathWayPoints = [];
        const bounds = new window.google.maps.LatLngBounds();
        if (arr?.length >= 2) {
            startPoints = {
                lat: Number(arr[0]?.place?.poi?.split(",")[0]),
                lng: Number(arr[0]?.place?.poi?.split(",")[1])
            };
            setStartPoints(startPoints)
            endPoints = {
                lat: Number(arr[arr?.length - 1]?.place?.poi?.split(",")[0]),
                lng: Number(arr[arr?.length - 1]?.place?.poi?.split(",")[1])
            };
            setEndPoints(endPoints)
            arr?.slice(1, -1)?.map((item) => {
                wayPoint = item?.place?.poi?.split(",")

                var way = {
                    location: {
                        lat: Number(wayPoint[0]),
                        lng: Number(wayPoint[1])
                    },
                    stopover: true,
                }
                showPathWayPoints?.push(way)
                setShowPathWayPoints(showPathWayPoints)
                bounds?.extend({
                    lat: Number(wayPoint[0]),
                    lng: Number(wayPoint[1])
                });
            })
        }
        else {
            toast.info("Please add more than 2 Points in your Routes.", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 2000
            })
            setShowPathSpinner(false);
        }

        if (startPoints !== undefined && endPoints !== undefined) {
            bounds?.extend(startPoints);
            bounds?.extend(endPoints);
        } else if (startPoints !== undefined && endPoints === undefined) {
            bounds?.extend(startPoints);
            bounds?.extend(center);
        } else if (endPoints !== undefined && startPoints === undefined) {
            bounds?.extend(endPoints);
            bounds?.extend(center);
        }
        else {
            bounds?.extend(center);
        }
        map?.fitBounds(bounds);
        setMap(map)
    }, []);

    const showPath = async () => {
        if (isUserLoggedIn) {
            const arr = location?.state?.data[0]?.arr
            setShowPathSpinner(true);
            let totalPoints = await getUserPoints({
                userName: userName
            });
            if (totalPoints?.data?.data?.userPoints === 0) {
                setShowPathSpinner(false);
                const notPoints = await swal({
                    title: "Failed to Show Path",
                    text: "Seems like you do not have enough points in your account.",
                    icon: "warning",
                    buttons: ["Cancel", "Buy Points"],
                })
                if (notPoints) {
                    navigate('/points')
                }
            }
            else {
                setShowPathSpinner(true);
                let data = {
                    userName: userName,
                    devicePlatform:
                        navigator?.userAgent?.indexOf("Win") !== -1 ? "WINDOWS"
                            : navigator?.userAgent?.indexOf("Android") !== -1 ? "ANDROID"
                                : navigator?.userAgent?.indexOf("like Mac") !== -1 ? "IOS"
                                    : navigator?.userAgent?.indexOf("Linux") !== -1 ? "LINUX"
                                        : navigator?.userAgent?.indexOf("Mac") !== -1 ? "MACINTOSH"
                                            : '',
                    pointsUsed: 1
                }
                await deductPoints(data);
                getPoints();
                const directionsService = new window.google.maps.DirectionsService();
                // const directionsDisplay = new window.google.maps.DirectionsRenderer();

                // directionsDisplay?.setMap(map);

                let start = startPoint;
                let end = endPoint;
                let wayPointsShowPath = showPathWayPoint;

                let request = {
                    origin: start,
                    waypoints: wayPointsShowPath,
                    destination: end,
                    optimizeWaypoints: true,
                    travelMode: "DRIVING",
                };

                if (arr?.length >= 2) {
                    directionsService?.route(request, async function (result, status) {
                        if (status === "OK") {
                            // directionsDisplay?.setDirections(result);
                            setDirectionResponse(result);
                            setMap(map);
                            setShowPathSpinner(false);
                        }
                        else {
                            toast.error("No paths found.", {
                                position: toast.POSITION.TOP_RIGHT,
                                autoClose: 2000
                            })
                            setShowPathSpinner(false);
                        }
                    });
                }
                else {
                    toast.info("Please add more than 2 Points in your Routes.", {
                        position: toast.POSITION.TOP_RIGHT,
                        autoClose: 2000
                    })
                    setShowPathSpinner(false);
                }

            }
        }
        else {
            const notLoggedIn = await swal({
                title: "Please Continue to Log In",
                text: "You want to show path?",
                icon: "warning",
                buttons: ["Cancel", "Log In"],
            })
            if (notLoggedIn) {
                navigate('/sign-in');
            }
        }
    }

    const isDisabled = () => {
        if (showPathSpinner === true) {
            return true
        }
    }

    const addPointInLast = async (id) => {
        if (isUserLoggedIn) {
            const arr = location?.state?.data[0]?.arr
            if (arr?.length < 25) {
                let index = location?.state?.data[0]?.index
                index = arr.length;
                let requestBody = [];
                arr?.splice(index, 0, {
                    mkmID: id,
                    orderNumber: 0,
                    visited: false
                });
                requestBody = arr?.map((item, i) => {
                    return {
                        mkmID: item?.place?.mkmID || item?.mkmID,
                        orderNumber: i,
                        visited: item?.visited
                    }
                });
                try {
                    let res = await updateRouteDetail(requestBody, {
                        userName: userName,
                        routeID: location?.state?.data[0]?.route_id,
                    });
                    if (res && res?.status === 200) {
                        setActiveMarker(null);
                        toast.success("Point Added Successfully In Your Route!", {
                            position: toast.POSITION.TOP_RIGHT,
                            autoClose: 2000
                        })
                        setTimeout(() => {
                            navigate(`/my-routes-detail/${location?.state?.data[0]?.route_id}/${location?.state?.data[0]?.route_name}`)
                        }, 1000);
                    }
                } catch (err) {
                    toast.error(
                        err?.response?.data?.message ||
                        "Oops.. something went wrong, try again !!!",
                        {
                            position: toast.POSITION.TOP_RIGHT,
                            autoClose: 2000,
                        }
                    );
                }
            }
            else {
                toast.warning("Max of only 25 credits can be added to a route, Kindly remove a point to add a new point.", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 2000
                })
            }
        }
        else {
            const notLoggedIn = await swal({
                title: "Please Continue to Log In",
                text: "You want to add this point in your Route?",
                icon: "warning",
                buttons: ["Cancel", "Log In"],
            })
            if (notLoggedIn) {
                navigate('/sign-in');
            }
        }
    }

    const addPointAbove = async (id) => {
        if (isUserLoggedIn) {
            const arr = location?.state?.data[0]?.arr
            if (arr?.length < 25) {
                const index = location?.state?.data[0]?.index
                let requestBody = [];
                arr?.splice(index, 0, {
                    mkmID: id,
                    orderNumber: 0,
                    visited: false
                });
                requestBody = arr?.map((item, i) => {
                    return {
                        mkmID: item?.place?.mkmID || item?.mkmID,
                        orderNumber: i,
                        visited: item?.visited
                    }
                });
                try {
                    let res = await updateRouteDetail(requestBody, {
                        userName: userName,
                        routeID: location?.state?.data[0]?.route_id,
                    });
                    if (res && res?.status === 200) {
                        setActiveMarker(null);
                        toast.success("Point Added Successfully In Your Route!", {
                            position: toast.POSITION.TOP_RIGHT,
                            autoClose: 2000
                        })
                        setTimeout(() => {
                            navigate(`/my-routes-detail/${location?.state?.data[0]?.route_id}/${location?.state?.data[0]?.route_name}`)
                        }, 1000);
                    }
                } catch (err) {
                    toast.error(
                        err?.response?.data?.message ||
                        "Oops.. something went wrong, try again !!!",
                        {
                            position: toast.POSITION.TOP_RIGHT,
                            autoClose: 2000,
                        }
                    );
                }
            } else {
                toast.warning("Max of only 25 credits can be added to a route, Kindly remove a point to add a new point.", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 2000
                })
            }
        }
        else {
            const notLoggedIn = await swal({
                title: "Please Continue to Log In",
                text: "You want to add this point in your Route?",
                icon: "warning",
                buttons: ["Cancel", "Log In"],
            })
            if (notLoggedIn) {
                navigate('/sign-in');
            }
        }
    }

    const share = (id, poi) => {
        const data = `${window?.location?.protocol}//${window?.location?.host}/category-detail/${id}/${poi}`
        setLink(data)
        setShowShareModal(true);
    }

    const reportSuggestion = (title, id) => {
        setMkmId(id)
        setPointName(title)
        setShowReportModal(true);
    }

    const handleActiveMarker = (marker) => {
        if (marker === activeMarker) {
            return;
        }
        setActiveMarker(marker);
    };

    const addToFavorite = async (id, fav) => {
        if (isUserLoggedIn) {
            const willFavorite = await swal({
                title: "Are you sure?",
                text: "You want to add this route in Favorites?",
                icon: marked_pop,
                buttons: true,
            })
            if (willFavorite) {
                try {
                    const obj = {
                        userName: userName
                    }
                    const data = {
                        mkmId: id,
                    }
                    const response = await addUserFavorite(data, obj)
                    setCheckForFavorite(fav);
                    if (response && response?.status === 200) {
                        swal("Added!", "Your route has been added in Favorites!", "success");
                    }

                } catch (error) {
                    toast.error(
                        error?.response?.data?.message ||
                        "Oops.. something went wrong, try again !!!",
                        {
                            position: toast.POSITION.TOP_RIGHT,
                            autoClose: 2000,
                        }
                    );
                }
            }
        }
        else {
            const notLoggedIn = await swal({
                title: "Please Continue to Log In",
                text: "You want to add this route in Favorites?",
                icon: marked_pop,
                buttons: ["Cancel", "Log In"],
            })
            if (notLoggedIn) {
                navigate('/sign-in');
            }
        }
    }

    const removeFromFavorite = async (id, fav) => {
        if (isUserLoggedIn) {
            const willRemoveFavorite = await swal({
                title: "Are you sure?",
                text: "You want to remove this route from Favorites?",
                icon: marked_pop,
                buttons: true,
            })
            if (willRemoveFavorite) {
                try {
                    const obj = {
                        userName: userName
                    }
                    const data = {
                        mkmId: id,
                    }
                    const response = await removeUserFavorite(data, obj)
                    setCheckForFavorite(fav);
                    if (response && response?.status === 200) {
                        swal("Removed!", "Your route has been removed from Favorites!", "success");
                    }
                } catch (error) {
                    toast.error(
                        error?.response?.data?.message ||
                        "Oops.. something went wrong, try again !!!",
                        {
                            position: toast.POSITION.TOP_RIGHT,
                            autoClose: 2000,
                        }
                    );
                }
            }
        }
        else {
            const notLoggedIn = await swal({
                title: "Please Continue to Log In",
                text: "You want to remove this route from Favorites?",
                icon: marked_pop,
                buttons: ["Cancel", "Log In"],
            })
            if (notLoggedIn) {
                navigate('/sign-in');
            }
        }
    }

    return (
        <div className='main_section along_route'>
            <Container>
            <ReportSuggestionModal
                showReportModal={showReportModal}
                setShowReportModal={setShowReportModal}
                showListModal={showListModal}
                setShowListModal={setShowListModal}
                setRouteName={setRouteName}
                routeName={routeName}
                pointName={pointName}
                mkmID={mkmID}
            />
            <ShareModal
                showShareModal={showShareModal}
                setShowShareModal={setShowShareModal}
                link={link}
                setLink={setLink}
            />
            {/* <SearchBar /> */}
            <div className='breadcrumb_section'>
                <Container >
                    <Breadcrumb className="breadcrumb">
                        <BreadcrumbItem>
                            <Link to="/" className="breadcrumb_item1">Home</Link>
                        </BreadcrumbItem>
                        <BreadcrumbItem>
                            <Link to="/my-routes" className="breadcrumb_item1">My Routes</Link>
                        </BreadcrumbItem>
                        {/* <BreadcrumbItem>
                            <Link to="/my-routes-detail" className="breadcrumb_item1">Details</Link>
                        </BreadcrumbItem> */}
                        <BreadcrumbItem active>
                            <Link to="#" className="breadcrumb_item2">Along Route</Link>
                        </BreadcrumbItem>
                    </Breadcrumb>
                </Container>
            </div>

            <div className="along_route_section">
                <Container fluid>
                    <div className="along_route_box">
                        <div className='map'>
                            {isLoaded ? (
                                <GoogleMap
                                    mapContainerStyle={containerStyle}
                                    onLoad={onLoad}
                                    zoom={12}
                                    options={options}
                                >
                                    {markers?.map(item =>
                                        <div key={item?.id}>
                                            <Marker
                                                position={{ lat: Number(item?.poi?.split(",")[0]), lng: Number(item?.poi?.split(",")[1]) }}
                                                onClick={() => handleActiveMarker(item?.id)}
                                                icon={{
                                                    url: item?.categoryId === 1
                                                        ? "http://maps.google.com/mapfiles/ms/icons/yellow-dot.png"
                                                        : item?.categoryId === 10
                                                            ? "http://maps.google.com/mapfiles/ms/icons/blue-dot.png"
                                                            : item?.categoryId === 5
                                                                ? "http://maps.google.com/mapfiles/ms/icons/purple-dot.png"
                                                                : item?.categoryId === 4
                                                                    ? require('../../assets/darkpurple.png')
                                                                    : item?.categoryId === 2
                                                                        ? "http://maps.google.com/mapfiles/ms/icons/ltblue-dot.png"
                                                                        : item?.categoryId === 7
                                                                            ? "http://maps.google.com/mapfiles/ms/icons/pink-dot.png"
                                                                            : item?.categoryId === 9
                                                                                ? require('../../assets/gray.png')
                                                                                : item?.categoryId === 12
                                                                                    ? require('../../assets/darkblue.png')
                                                                                    : require('../../assets/lightpink.png')
                                                }}
                                            >
                                                {activeMarker === item?.id ? (
                                                    <InfoWindow onCloseClick={() => setActiveMarker(null)}>
                                                        <div className="info_window"> <Card body>
                                                            <div className="card_header">
                                                                {item?.userFavorite === true ? <Button className='favourite_fill_icon'
                                                                    onClick={() => removeFromFavorite(item?.id)}
                                                                ><AiFillStar size={20} /></Button> :
                                                                    <Button className="favourite_icon"
                                                                        onClick={() => addToFavorite(item?.id)}
                                                                    ><AiOutlineStar size={20} /></Button>
                                                                }
                                                                <div className="right_section">
                                                                {item?.categoryId === 12 ?
                                                                    <Link to={`/category-detail/?tzadikimId=${item?.id}&cor=${item?.poi}`} state={{ from: 'alongPreviousPoint', data: location?.state?.data , categoryName : 'tzadikim' }} className='card_link'>
                                                                        <CardTitle tag="h5" title={item?.mkmTitle}>{item?.mkmTitle}</CardTitle>
                                                                    </Link>
                                                                    :
                                                                    <Link to={`/category-detail/?MkmId=${item?.id}&cor=${item?.poi}`} state={{ from: 'alongPreviousPoint', data: location?.state?.data , categoryName : item?.categoryId === 1 ? 'Cemeteries' : '' }} className='card_link'>
                                                                        <CardTitle tag="h5" title={item?.mkmTitle}>{item?.mkmTitle}</CardTitle>
                                                                    </Link>
                                                                }
                                                                    <Dropdown className="moreInfo" toggle={() => { setMenuOpen(!dropdownMenuOpen) }}
                                                                        isOpen={dropdownMenuOpen}
                                                                    >
                                                                        <DropdownToggle>
                                                                            <BiDotsVerticalRounded size={20} />
                                                                        </DropdownToggle>
                                                                        <DropdownMenu>
                                                                            <DropdownItem >
                                                                                <Link to={`/along-the-way-to-here/${item?.poi}`} state={{ from: 'alongRoute', data: location?.state?.data }} className="breadcrumb_item1">Along the way to here</Link>
                                                                            </DropdownItem>
                                                                            <DropdownItem onClick={() => reportSuggestion(item?.mkmTitle, item?.id)}>
                                                                                Report suggestion
                                                                            </DropdownItem>
                                                                        </DropdownMenu>
                                                                    </Dropdown>

                                                                </div>
                                                            </div>
                                                            <CardText>
                                                                {item?.cityY+ " "} &nbsp; {item?.stateY}
                                                            </CardText>
                                                            <div className="card_bottom">
                                                                <Button onClick={() => share(item?.id, item?.poi)}><FiShare2 size={20} /></Button>
                                                                <div className="right_section">
                                                                <CardText className='location'>
                                                                    {item?.cityE + " "} &nbsp; {item?.stateE}
                                                                    <MdLocationOn className="location_icon" size={18} />
                                                                </CardText>
                                                                </div>
                                                            </div>
                                                            <div className="card_footer">
                                                                <Link to={`/explore-near-by/${item?.poi}`} state={{ from: 'alongRoute', data: location?.state?.data }} className="btn explore"><BiExitFullscreen className="explore_icon" />Explore Near By</Link>
                                                                {item?.categoryId === 12 ?
                                                                    <Link to={`/category-detail/?tzadikimId=${item?.id}&cor=${item?.poi}`} state={{ from: 'alongRoute', data: location?.state?.data , categoryName : 'tzadikim' }} className="btn viewmore">View More</Link>
                                                                    :
                                                                    <Link to={`/category-detail/?MkmId=${item?.id}&cor=${item?.poi}`} state={{ from: 'alongRoute', data: location?.state?.data , categoryName : item?.categoryId === 1 ? 'Cemeteries' : ''}} className="btn viewmore">View More</Link>
                                                                }
                                                                <Button className="btn addroute" onClick={() => addToRoute(item?.id)}><FiBriefcase className="addroute_icon" />Add to Route</Button>
                                                            </div>
                                                        </Card></div>
                                                    </InfoWindow>
                                                ) : null}
                                            </Marker>
                                        </div>
                                    )}
                                    <></>
                                    {isUserLoggedIn &&
                                        <>
                                            {directionResponse && <DirectionsRenderer directions={directionResponse} />}
                                        </>
                                    }
                                </GoogleMap>
                            ) : <></>}
                            <div className='map_footer'>
                                <Button onClick={() => showPath()} disabled={isDisabled()}>
                                    {showPathSpinner === true ? <Spinner size="sm"></Spinner> : <>
                                        Show Path
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <circle cx="12" cy="12" r="11" stroke="#FFFFFF" strokeWidth="2" />
                                            <path d="M7.4375 6.9375H8.70312L15.8281 15.6719V6.9375H17.1172V18H15.9062L8.72656 9.20312V18H7.4375V6.9375Z" fill="#FFFFFF" />
                                            <path d="M7.4375 6.9375V6.4375H6.9375V6.9375H7.4375ZM8.70312 6.9375L9.09057 6.62145L8.94051 6.4375H8.70312V6.9375ZM15.8281 15.6719L15.4407 15.9879L16.3281 17.0758V15.6719H15.8281ZM15.8281 6.9375V6.4375H15.3281V6.9375H15.8281ZM17.1172 6.9375H17.6172V6.4375H17.1172V6.9375ZM17.1172 18V18.5H17.6172V18H17.1172ZM15.9062 18L15.5189 18.3162L15.6689 18.5H15.9062V18ZM8.72656 9.20312L9.11392 8.88697L8.22656 7.79974V9.20312H8.72656ZM8.72656 18V18.5H9.22656V18H8.72656ZM7.4375 18H6.9375V18.5H7.4375V18ZM7.4375 7.4375H8.70312V6.4375H7.4375V7.4375ZM8.31568 7.25355L15.4407 15.9879L16.2156 15.3558L9.09057 6.62145L8.31568 7.25355ZM16.3281 15.6719V6.9375H15.3281V15.6719H16.3281ZM15.8281 7.4375H17.1172V6.4375H15.8281V7.4375ZM16.6172 6.9375V18H17.6172V6.9375H16.6172ZM17.1172 17.5H15.9062V18.5H17.1172V17.5ZM16.2936 17.6838L9.11392 8.88697L8.3392 9.51928L15.5189 18.3162L16.2936 17.6838ZM8.22656 9.20312V18H9.22656V9.20312H8.22656ZM8.72656 17.5H7.4375V18.5H8.72656V17.5ZM7.9375 18V6.9375H6.9375V18H7.9375Z" fill="#FFFFFF" />
                                        </svg>
                                    </>}
                                </Button>
                            </div>
                        </div>
                    </div>
                </Container>
            </div>
            </Container>
        </div>
    )
}

export default AlongRoute